import { ReadAllResponse, uuid } from "@/interfaces";
import { Survey, SurveyQuestionDraft } from "@/models/survey.model";
import { SurveyRepository } from "@/repositories/survey.repository";

export async function fetchServiceSurveys(service: uuid): Promise<ReadAllResponse<Survey>> {
  return SurveyRepository.getAll(service);
}

export async function insertSurveyQuestion({ service, draft }: { service: uuid; draft: SurveyQuestionDraft }): Promise<ReadAllResponse<Survey>> {
  return SurveyRepository.createSurveyQuestion(service, draft);
}

export async function deleteSurveyQuestion({ service, question }: { service: uuid; question: uuid }): Promise<ReadAllResponse<Survey>> {
  return SurveyRepository.deleteSurveyQuestion(service, question);
}
